import { constraints } from '@yola/ws-sdk';
import { GRADIENT, DEFAULT, BORDERLESS_FILLED } from '../constants/appearance';

const getHighlighterAppearance = (element, options) => {
  if (options.hovered) {
    return BORDERLESS_FILLED;
  }

  if (constraints.verifiers.canBeSpaceResizable(element)) {
    return GRADIENT;
  }

  return DEFAULT;
};

export default getHighlighterAppearance;
